












import { Component, Prop, Vue } from "vue-property-decorator";

import ServiceStatusUpdateArea from "@/components/service-status/ServiceStatusUpdateArea.vue";

@Component({
  components: { ServiceStatusUpdateArea },
})
export default class ServiceStatusUpdateHeader extends Vue {
  @Prop({ default: null }) private updatedTime!: number | null;
  @Prop({ default: false }) private loading!: boolean;
}
